// @ts-nocheck
import React, { FC, useState, useEffect } from 'react';
import cn from 'classnames';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { useField } from 'informed';
import { DATE_FORMAT } from '@common/constants';
import css from './styles.module.scss';

export interface IDateField {
  name: string;
  dateFormat?: string;
  placeholder?: string;
  validate?: (value: string) => void | string;
  className?: string;
  labelClassName?: string;
  errorClassName?: string;
  label?: string | JSX.Element;
  showTimeSelect?: boolean;
  showTimeSelectOnly?: boolean;
  storeDateFormat?: string;
  timeIntervals?: number;
  timeCaption?: string | null;
  timeFormat?: string;
  initialValue?: Date;
  onChange?: (value: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  dayClassName?: (value: Date) => string | undefined;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
  dropdownMode?: string;
  minTime?: Date;
  maxTime?: Date;
  disabled?: boolean;
  icon?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DateField: FC<IDateField> = (props: any) => {
  const { fieldState, fieldApi, render, ref, userProps } = useField(props);

  const { error, value } = fieldState;

  const { setValue, setTouched, validate, reset } = fieldApi;
  const {
    onChange,
    placeholder,
    className,
    labelClassName,
    errorClassName,
    dateFormat = DATE_FORMAT.DATEPICKER,
    storeDateFormat,
    label,
    dropdownMode = 'select',
    showMonthDropdown = true,
    showYearDropdown = true,
    id,
    ...rest
  } = userProps;

  const [dateValue, setDateValue] = useState<Date | null>(value instanceof Date ? value : null);
  const selectedValue = !dateValue ? '' : dateValue;
  const MONTH_FORMAT = 'MM/yyyy';

  useEffect(() => {
    if (value && value instanceof Date) {
      setDateValue(value);
    }
  }, [value]);

  return render(
    <>
      {label && (
        <label htmlFor={id} className={cn(css.label, labelClassName)}>
          {label}
        </label>
      )}
      <DatePicker
        ref={ref}
        onFocus={() => setTouched(true)}
        onChange={(date: Date) => {
          const formattedDate = storeDateFormat ? moment(date).format(storeDateFormat) : date;

          if (date) {
            setValue(formattedDate);
            setDateValue(date);
          } else {
            setDateValue(null);
            reset();
          }

          validate();
          onChange?.(formattedDate);
        }}
        className={cn(css.field, className, { fieldError: error })}
        selected={dateValue}
        shouldCloseOnSelect
        openToDate={selectedValue}
        placeholderText={placeholder}
        dateFormatCalendar="MMMM"
        dateFormat={dateFormat}
        id={id}
        dropdownMode={dropdownMode}
        showMonthDropdown={showMonthDropdown}
        showYearDropdown={showYearDropdown}
        popperClassName={dateFormat === MONTH_FORMAT ? css['month-calendar-popper'] : null}
        showMonthYearPicker={dateFormat === MONTH_FORMAT}
        {...rest}
      />
      {error ? <p className={cn(css.error, errorClassName)}>{error as string}</p> : null}
    </>,
  );
};

export default DateField;
